import { App } from './App';
import { loadData } from './loadData';

export * from './types';

export {
  App as component,
  loadData,
};
